import { ImageOrientation } from '@space-core/components/customImage/enum'
import clsx from 'clsx'
import styled from 'styled-components'

import type { CardProps } from './types'

import DefaultBaseCard from '../base/default'
import { CardOrientation } from '../base/enum'

const Wrapper = styled.div`
  bottom: 0;
  opacity: 0;
`

const Description = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`

const BundleCardDefault = ({
  bundle,
  items,
  orientation,
  containerOrientation,
  imageOrientation,
  themeMode
}: CardProps) => {
  const contentContainerClass = clsx(
    '_d-flex _flex-column _justify-content-center _align-items-start _h-full',
    {
      '_p-0 _pt-4': orientation === CardOrientation.VERTICAL
    }
  )

  return (
    <DefaultBaseCard
      themeMode={themeMode}
      thumbnailImage={bundle.thumbnailImage}
      orientation={orientation}
      containerOrientation={containerOrientation}
      imageOrientation={imageOrientation}
      items={items}
      showDepthEffect>
      {imageOrientation === ImageOrientation.HORIZONTAL && (
        <div className={contentContainerClass}>
          <h3 className='_font-18 _text-gray-900 _font-weight-bold _text-left _mb-1 _py-1'>
            {bundle.name}
          </h3>

          <Description className='_font-14 _text-left _text-gray-600 _mb-1 _w-full'>
            {bundle.description}
          </Description>

          {bundle.showOfferPrice && (
            <p
              className='_m-0 _text-2 _font-weight-bold _text-green'
              data-test='bundle-custom-card-price'>
              {bundle.price}
            </p>
          )}
        </div>
      )}
      {imageOrientation === ImageOrientation.VERTICAL && (
        <Wrapper className='_w-full _child-vertical _position-absolute _p-5'>
          <div>
            <h3 className='_font-18 _text-gray-900 _font-weight-bold _text-left _mb-1'>
              {bundle.name}
            </h3>

            <Description className='_font-14 _text-left _text-gray-600 _mb-1 _w-full'>
              {bundle.description}
            </Description>

            {bundle.showOfferPrice && bundle.price && (
              <p
                className='_m-0 _text-2 _font-weight-bold _text-green'
                data-test='bundle-custom-card-price'>
                {bundle.price}
              </p>
            )}
          </div>
        </Wrapper>
      )}
    </DefaultBaseCard>
  )
}

export default BundleCardDefault
